import {FormControl, FormGroup} from "@angular/forms";
import {environment} from "../../../../../environments/environment.dev";

export type InstallationDirections = 'HORIZONTAL' | 'VERTICAL' | 'BOTH';

export type LamellaForm = {
    lamellaCategory: FormControl<number>,
    usesFixplate: FormControl<boolean>,
    usesLockingScrew: FormControl<boolean>,
    installationDirection: FormControl<InstallationDirections>,
    spaceTaken: FormControl<number>,
    minSpaceTop: FormControl<number>,
    minSpaceBottom: FormControl<number>,
    minSpace: FormControl<number>
    maxSpace: FormControl<number>
    maxFrameSpan: FormControl<number>
}

export function getNewLamellaForm(lamella: any = undefined){
    const lamellaCategory = environment.lamellaFamilies.findIndex(i=>i===lamella?.lamellaCategory) + 1;
    return new FormGroup( <LamellaForm> {
        lamellaCategory: new FormControl(lamellaCategory > 0 ? lamellaCategory : 1 ),
        usesFixplate: new FormControl(lamella?.usesFixplate ?? false),
        usesLockingScrew: new FormControl(lamella?.usesLockingScrew ?? false),
        installationDirection: new FormControl(lamella?.installationDirection ?? 'BOTH'),
        spaceTaken: new FormControl(lamella?.spaceTaken ?? 26.5),
        minSpaceTop: new FormControl(lamella?.minSpaceTop ?? 53),
        minSpaceBottom: new FormControl(lamella?.minSpaceBottom ?? 53),
        minSpace: new FormControl(lamella?.minSpace ?? 26.5),
        maxSpace: new FormControl(lamella?.maxSpace ?? 265),
        maxFrameSpan: new FormControl(lamella?.maxFrameSpan ?? 1500)
    })
}